import { useAgencyStartOfWeek } from '~/libraries/agencies/queries';
import { getCadenceCorrelator } from './util';

export type GetCadenceCorrelatorFunc = (frequencyCadenceTypeId: number, scheduledDateAndTime: Date) => number;

export type IsSameCadenceCorrelatorFunc = (frequencyCadenceTypeId: number, scheduledDateAndTime1: Date, scheduledDateAndTime2: Date) => boolean;

export function useCadenceCorrelator(): { getCadenceCorrelator: GetCadenceCorrelatorFunc; isSameCadenceCorrelator: IsSameCadenceCorrelatorFunc } {
	const agencyStartOfWeek = useAgencyStartOfWeek();
	return {
		getCadenceCorrelator: (frequencyCadenceTypeId: number, scheduledDateAndTime: Date) =>
			getCadenceCorrelator(frequencyCadenceTypeId, scheduledDateAndTime, agencyStartOfWeek),
		isSameCadenceCorrelator: (frequencyCadenceTypeId: number, scheduledDateAndTime1: Date, scheduledDateAndTime2: Date) =>
			getCadenceCorrelator(frequencyCadenceTypeId, scheduledDateAndTime1, agencyStartOfWeek) ===
			getCadenceCorrelator(frequencyCadenceTypeId, scheduledDateAndTime2, agencyStartOfWeek)
	};
}
